export const countNights = (startDate,endDate) => {
    if (!startDate || !endDate) return 1;
    let diff = endDate.getTime() - startDate.getTime();
    let nights = diff / (1000 * 3600 * 24);
    return nights < 1 ? 1 : Math.round(nights);
}